import { createSelector } from 'reselect';
import { getPOSSteps } from '@olxbr/mojo-jojo/selectors/pos';

export const getExitPopupData = state => state.ui.get('exitPopup').toJS();
export const getOlxProPopup = state => state.ui.get('olxProPopup');
export const isLoading = state => state.ui.get('loading');
export const getSelectedCharacteristic = state => state.ui.get('selectedCharacteristic');

export const getCurrentStepName = state => state.ui.get('currentStep');
export const getCurrentStep = createSelector(
  getCurrentStepName,
  getPOSSteps,
  (stepName, steps) => steps.find(step => step.name === stepName),
);

export const getModalData = state => state.ui.get('modal').toJS();

export default {
  getExitPopupData,
  getCurrentStepName,
  getOlxProPopup,
  getSelectedCharacteristic,
};
